import { render, staticRenderFns } from "./doacFollowup.vue?vue&type=template&id=6728d9a0&scoped=true&"
import script from "./doacFollowup.vue?vue&type=script&lang=js&"
export * from "./doacFollowup.vue?vue&type=script&lang=js&"
import style0 from "./doacFollowup.vue?vue&type=style&index=0&id=6728d9a0&prod&lang=scss&scoped=true&"
import style1 from "./doacFollowup.vue?vue&type=style&index=1&id=6728d9a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728d9a0",
  null
  
)

export default component.exports